import { createI18n } from 'vue-i18n'
import en from './locales/en'

// English is the only locale for now (owner decision 2026-08-10, tech spec §12).
// vue-i18n and the catalogue structure stay so a second language is a new file
// plus one entry here, with no call-site changes.
export type AvailableLocales = 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'en',
    fallbackLocale:   'en',
    messages:         { en },
    availableLocales: ['en'],
})

export default i18n
